import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {
    getBusinessApproach,
    getBusinessStory,
    updateBusinessApproach,
    updateBusinessStory
} from "../../actions/BusinessPages";
import {IMAGE_URL} from "../../path";
import 'react-quill/dist/quill.snow.css';

function EditOurApproachPage() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const user = location.state?.user;
    const [approach, setApproach] = useState<any[]>([]);
    const [section1Right, setSection1Right] = useState('');
    const [section2Right, setSection2Right] = useState('');
    const [imageFileDesktop1, setImageFileDesktop1] = useState<File | null>(null);
    const [previewUrlDesktop1, setPreviewUrlDesktop1] = useState<string>('');
    const [imageFileMobile1, setImageFileMobile1] = useState<File | null>(null);
    const [previewUrlMobile1, setPreviewUrlMobile1] = useState<string>('');
    const [imageFileDesktop2, setImageFileDesktop2] = useState<File | null>(null);
    const [previewUrlDesktop2, setPreviewUrlDesktop2] = useState<string>('');
    const [imageFileMobile2, setImageFileMobile2] = useState<File | null>(null);
    const [previewUrlMobile2, setPreviewUrlMobile2] = useState<string>('');
    const [image1Error, setImage1Error] = useState<string>("");
    const [image2Error, setImage2Error] = useState<string>("");

    const [image1Title, setImage1Title] = useState<string>("");
    const [image1FullWidth, setImage1FullWidth] = useState<boolean>(false);
    const [image2Title, setImage2Title] = useState<string>("");
    const [image2FullWidth, setImage2FullWidth] = useState<boolean>(false);

    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, type: "desktop" | "mobile", id: 1 | 2) => {
        const file = e.target.files?.[0];
        if (id == 1) {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                    setImage1Error("Please upload a valid image file (jpg, jpeg, or png).");
                    if (type === "desktop") setImageFileDesktop1(null);
                    else setImageFileMobile1(null);
                    return;
                }

                setImage1Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                    setImageFileDesktop1(file);
                    setPreviewUrlDesktop1(objectUrl);
                } else {
                    setImageFileMobile1(file);
                    setPreviewUrlMobile1(objectUrl);
                }
            }
        } else {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                    setImage2Error("Please upload a valid image file (jpg, jpeg, or png).");
                    if (type === "desktop") setImageFileDesktop2(null);
                    else setImageFileMobile2(null);
                    return;
                }

                setImage2Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                    setImageFileDesktop2(file);
                    setPreviewUrlDesktop2(objectUrl);
                } else {
                    setImageFileMobile2(file);
                    setPreviewUrlMobile2(objectUrl);
                }
            }
        }

    };

    useEffect(() => {
        getBusinessApproach()
            .then(response => {
                const data = response.data;
                setApproach(data);

                setSection1Right(data[1]?.right_text || '');
                setSection2Right(data[2]?.right_text || '');

                // Set preview image URLs
                setPreviewUrlDesktop1(IMAGE_URL  + data[0]?.image);
                setPreviewUrlMobile1(IMAGE_URL  + data[0]?.mobile_image);
                setPreviewUrlDesktop2(IMAGE_URL  + data[3]?.image);
                setPreviewUrlMobile2(IMAGE_URL  + data[3]?.mobile_image);

                // Set full width values from the image entries
                setImage1FullWidth(!!data[0]?.is_full);
                setImage2FullWidth(!!data[3]?.is_full);
            })
            .catch(error => {
                // console.error("Failed to fetch business story:", error);
            });
    }, []);

    const saveApproach = async () => {
        try {
            const formData = new FormData();

            // Append text content
            formData.append("section1", section1Right);
            formData.append("section2R", section2Right);

            // Append images if selected
            if (imageFileDesktop1) formData.append("image1", imageFileDesktop1);
            if (imageFileMobile1) formData.append("mobile_image1", imageFileMobile1);
            if (imageFileDesktop2) formData.append("image2", imageFileDesktop2);
            if (imageFileMobile2) formData.append("mobile_image2", imageFileMobile2);

            // Append full width settings
            formData.append("is_full_1", image1FullWidth.toString());
            formData.append("is_full_2", image2FullWidth.toString());

            // Use the imported API method
            const response = await updateBusinessApproach(formData);

            if (response.status === 201) {
                alert("Business approach saved successfully!");
            } else {
                console.error("Save failed:", response.data);
                alert("Failed to save. Please try again.");
            }
        } catch (error) {
            console.error("Error saving business approach:", error);
            alert("An error occurred while saving.");
        }
    }

    const removeSelectedImage = (type: "desktop" | "mobile", id: 1 | 2) => {
        if (type === "desktop") {
            if (id == 1) {

                setImageFileDesktop1(null);
                setPreviewUrlDesktop1(`${IMAGE_URL}${approach[0].image}`);
            }
            else {
                setImageFileDesktop2(null);
                setPreviewUrlDesktop2(`${IMAGE_URL}${approach[3].image}`);
            }

        } else {
            if (id == 1) {
                setImageFileMobile1(null);
                setPreviewUrlMobile1(`${IMAGE_URL}${approach[1].mobile_image}`);
            } else {
                setImageFileMobile2(null);
                setPreviewUrlMobile2(`${IMAGE_URL}${approach[3].mobile_image}`);
            }

        }
    };

    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="main-admin-page-inner">
                <label><strong>{approach[1]?.title}</strong></label>
                <ReactQuill
                    id="section1Right"
                    value={section1Right}
                    onChange={setSection1Right}
                    modules={modules}
                    style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }}
                />
            </div>
        </div>

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px',   }}>
                <input
                    type="text"
                    value={image1Title}
                    onChange={(e) => setImage1Title(e.target.value)}
                    placeholder="Image 1 Title"
                    style={{ width: '70%' }}
                />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginRight: '10px' }}>Full Width:</label>
                    <input
                        type="checkbox"
                        checked={image1FullWidth}
                        onChange={(e) => setImage1FullWidth(e.target.checked)}
                    />
                </div>
            </div>
            <div className={`images-flex ${image1FullWidth ? 'full-width' : ''}`}>
                {/* First Desktop/Mobile Image Upload Components */}
                <div>
                    {/* Desktop Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Desktop Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "desktop", 1)}
                            style={{ margin: '10px 0' }}
                        />
                        {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
                        {previewUrlDesktop1 && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlDesktop1}
                                    alt="Desktop Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button type="button" onClick={() => removeSelectedImage("desktop", 1)} style={{ marginTop: '5px' }}>
                                    Remove Desktop Image
                                </button>
                            </div>
                        )}
                    </div>


                </div>
                <div>
                    {/* Mobile Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Mobile Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "mobile", 1)}
                            style={{ margin: '10px 0' }}
                        />
                        {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
                        {previewUrlMobile1 && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlMobile1}
                                    alt="Mobile Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button type="button" onClick={() => removeSelectedImage("mobile", 1)} style={{ marginTop: '5px' }}>
                                    Remove Mobile Image
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="main-admin-page-inner">
                <label><strong>{approach[2]?.title}</strong></label>
                <ReactQuill
                    id="section2Right"
                    value={section2Right}
                    onChange={setSection2Right}
                    modules={modules}
                    style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }}
                />
            </div>
        </div>

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px',   }}>
                <input
                    type="text"
                    value={image2Title}
                    onChange={(e) => setImage2Title(e.target.value)}
                    placeholder="Image 2 Title"
                    style={{ width: '70%' }}
                />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginRight: '10px' }}>Full Width:</label>
                    <input
                        type="checkbox"
                        checked={image2FullWidth}
                        onChange={(e) => setImage2FullWidth(e.target.checked)}
                    />
                </div>
            </div>
            <div className={`images-flex ${image1FullWidth ? 'full-width' : ''}`}>
                {/* First Desktop/Mobile Image Upload Components */}
                <div>
                    {/* Desktop Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Desktop Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "desktop", 2)}
                            style={{ margin: '10px 0' }}
                        />
                        {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
                        {previewUrlDesktop2 && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlDesktop2}
                                    alt="Desktop Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button type="button" onClick={() => removeSelectedImage("desktop", 2)} style={{ marginTop: '5px' }}>
                                    Remove Desktop Image
                                </button>
                            </div>
                        )}
                    </div>


                </div>
                <div>
                    {/* Mobile Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Mobile Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, "mobile", 2)}
                            style={{ margin: '10px 0' }}
                        />
                        {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
                        {previewUrlMobile2 && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlMobile2}
                                    alt="Mobile Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button type="button" onClick={() => removeSelectedImage("mobile", 2)} style={{ marginTop: '5px' }}>
                                    Remove Mobile Image
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>

        <div style={{ marginTop: '30px' }}>
            <button onClick={saveApproach} style={{ padding: '10px 20px', fontSize: '16px' }}>
                Save Changes
            </button>
        </div>


    </div>
}

export default EditOurApproachPage;
